import {animate, createTimeline, JSAnimation, splitText, spring, stagger, TextSplitter, Timeline} from "animejs";

export class NavigationAnimations {
    public mainNavEl: HTMLElement | undefined;
    public mainNavElAnimation: JSAnimation | undefined;
    public mainNavOnCompleteCallback: (() => void) | null = null;

    public playMainNavIntroAnimation(): Promise<void> {
        this.mainNavEl = document.querySelector("#MainNav") as HTMLElement;

        return new Promise<void>((resolve) => {
            this.mainNavOnCompleteCallback = resolve;

            if (this.mainNavEl) {
                this.mainNavElAnimation = animate(this.mainNavEl, {
                    width: "100%",
                    duration: 1000,
                    autoplay: true,
                    onComplete: self => {
                        if (this.mainNavOnCompleteCallback) {
                            this.mainNavOnCompleteCallback();
                            this.mainNavOnCompleteCallback = null;
                        }
                    }
                });
            }
        });
    }

    public hideNavLinksContainer(): void {
        const navLinksContainer = document.querySelector(".nf-text-nav") as HTMLElement;
        if (navLinksContainer) {
            navLinksContainer.classList.add("opacity-0");
        }
    }

    public showNavLinksContainer(): void {
        const navLinksContainer = document.querySelector(".nf-text-nav") as HTMLElement;
        if (navLinksContainer) {
            navLinksContainer.classList.remove("opacity-0");
        }
    }
    
    public playNavLogoIntroAnimation(): void {
        const logoAnimTimeline: Timeline = createTimeline();
        
        logoAnimTimeline
            .add("#CharNLeft", { 
                scale: [0, 1],
                ease: spring({ bounce: .4, duration: 200 }),
            })
            .add("#CharNCenter", { 
                scale: [0, 1], 
                ease: spring({ bounce: .4, duration: 250 })
                },
                250)
            .add("#CharNRight", {
                scale: [0, 1],
                ease: spring({ bounce: .4, duration: 250 })
                },
                500)
            .add("#CharFLeft", {
                scale: [0, 1],
                ease: spring({ bounce: .5, duration: 300 },)
                },
                750)
            .add("#CharFTop", {
                scale: [0, 1],
                ease: spring({ bounce: .3, duration: 400 },)
                },
                1000)
            .add("#CharFMid", {
                scale: [0, 1],
                ease: spring({ bounce: .5, duration: 500 },)
                },
                1250);
    }
    
    public setNavCharsOpacityZero(): void {
        let charSplitHome: TextSplitter = splitText("#NavLinkItem_HOME", {
            chars: { wrap: "clip" }
        });
        let charSplitAbout: TextSplitter = splitText("#NavLinkItem_ABOUT", {
            chars: { wrap: "clip" }
        });
        let charSplitWork: TextSplitter = splitText("#NavLinkItem_WORK", {
            chars: { wrap: "clip" }
        });
        let charSplitBlog: TextSplitter = splitText("#NavLinkItem_BLOG", {
            chars: { wrap: "clip" }
        });

        charSplitHome.chars.forEach(char => {
            char.style.opacity = "0";
        });
        charSplitAbout.chars.forEach(char => {
            char.style.opacity = "0";
        });
        charSplitWork.chars.forEach(char => {
            char.style.opacity = "0";
        });
        charSplitBlog.chars.forEach(char => {
            char.style.opacity = "0";
        });
    }

    public setNavCharsOpacityOne(): void {
        let charSplitHome: TextSplitter = splitText("#NavLinkItem_HOME", {
            chars: { wrap: "clip" }
        });
        let charSplitAbout: TextSplitter = splitText("#NavLinkItem_ABOUT", {
            chars: { wrap: "clip" }
        });
        let charSplitWork: TextSplitter = splitText("#NavLinkItem_WORK", {
            chars: { wrap: "clip" }
        });
        let charSplitBlog: TextSplitter = splitText("#NavLinkItem_BLOG", {
            chars: { wrap: "clip" }
        });

        charSplitHome.chars.forEach(char => {
            char.style.opacity = "1";
        });
        charSplitAbout.chars.forEach(char => {
            char.style.opacity = "1";
        });
        charSplitWork.chars.forEach(char => {
            char.style.opacity = "1";
        });
        charSplitBlog.chars.forEach(char => {
            char.style.opacity = "1";
        });
    }
    
    public playNavLinkItemTextAnimation(): void {
        let charSplitHome: TextSplitter = splitText("#NavLinkItem_HOME", {
            chars: { wrap: "clip" }
        });
        let charSplitAbout: TextSplitter = splitText("#NavLinkItem_ABOUT", {
            chars: { wrap: "clip" }
        });
        let charSplitWork: TextSplitter = splitText("#NavLinkItem_WORK", {
            chars: { wrap: "clip" }
        });
        let charSplitBlog: TextSplitter = splitText("#NavLinkItem_BLOG", {
            chars: { wrap: "clip" }
        });
        
        let textAnimTimeLine: Timeline = createTimeline({
            duration: 1500,
            delay: 500
        });
        
        textAnimTimeLine.reset();
        
        textAnimTimeLine
            .add(charSplitHome.chars, {
                opacity: 1,
                duration: 250,
                delay: stagger(50),
            })
            .add(charSplitAbout.chars, {
                opacity: 1,  // Animate TO visible
                duration: 250,  // Shorter duration per character for snappier typing
                delay: stagger(50),  // 50ms delay between each character
            }, 150)
            .add(charSplitWork.chars, {
                opacity: 1,  // Animate TO visible
                duration: 250,  // Shorter duration per character for snappier typing
                delay: stagger(50),  // 50ms delay between each character
            }, 300)
            .add(charSplitBlog.chars, {
                opacity: 1,  // Animate TO visible
                duration: 250,  // Shorter duration per character for snappier typing
                delay: stagger(50),  // 50ms delay between each character
            }, 550)
    }
}